<template>
  <div class="no-center-title-description">
    <h2>{{ translationsStore.t("no_center_title") }}</h2>
    <p class="description">
      {{ translationsStore.t("no_center_description") }}
    </p>
  </div>
  <div class="no-center-push-wrapper">
    <div class="section-stack">
      <div class="media-blocks">
        <media-block class="h-full">
          <a
            :href="content[0].url"
            class="media-blocks__item @container/content-box color-scheme color-scheme--scheme-1"
          >
            <div class="content-box h-full min-h-auto">
              <div class="content-box__background-media">
                <img
                  :src="`${content[0].image.url}&amp;width=656`"
                  alt=""
                  :srcset="`
                    ${content[0].image.url}&amp;width=300 300w,
                    ${content[0].image.url}&amp;width=400 400w,
                    ${content[0].image.url}&amp;width=500 500w,
                    ${content[0].image.url}&amp;width=600 600w
                  `"
                  width="656"
                  height="656"
                  sizes="(max-width: 699px) 100vw, 50vw"
                  class="size-full"
                />
              </div>
              <div class="placement-grid">
                <div class="prose prose-justify-center">
                  <p class="h4">
                    {{ translationsStore.t("no_center_push_1_title") }}
                  </p>
                  <AnimatedButton
                    :label="translationsStore.t('no_center_push_1_btn_label')"
                  />
                </div>
              </div>
            </div>
          </a>
        </media-block>
        <media-block class="h-full">
          <a
            :href="content[1].url"
            class="media-blocks__item @container/content-box color-scheme color-scheme--scheme-1"
          >
            <div class="content-box h-full min-h-auto">
              <div class="content-box__background-media">
                <img
                  :src="`${content[1].image.url}&amp;width=2880`"
                  alt=""
                  :srcset="`
                    ${content[1].image.url}&amp;width=300   300w,
                    ${content[1].image.url}&amp;width=400   400w,
                    ${content[1].image.url}&amp;width=500   500w,
                    ${content[1].image.url}&amp;width=600   600w,
                    ${content[1].image.url}&amp;width=800   800w,
                    ${content[1].image.url}&amp;width=1000 1000w,
                    ${content[1].image.url}&amp;width=1200 1200w,
                    ${content[1].image.url}&amp;width=1400 1400w,
                    ${content[1].image.url}&amp;width=1600 1600w,
                    ${content[1].image.url}&amp;width=1800 1800w
                  `"
                  width="2880"
                  height="2800"
                  loading="lazy"
                  sizes="(max-width: 699px) 100vw, (max-width: 999px) 50vw, 50vw"
                  class="size-full"
                />
              </div>
              <div class="placement-grid">
                <div class="prose prose-justify-center">
                  <p class="h4">
                    {{ translationsStore.t("no_center_push_2_title") }}
                  </p>
                  <AnimatedButton
                    :label="translationsStore.t('no_center_push_2_btn_label')"
                  />
                </div>
              </div>
            </div>
          </a>
        </media-block>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useTranslationsStore } from "../stores/translations";
import AnimatedButton from "./AnimatedButton.vue";
const translationsStore = useTranslationsStore();

defineProps({
  content: {
    type: Array,
    default: () => [],
  },
});
</script>

<style scoped>
.no-center-title-description {
  padding: 2rem 1rem;
  text-align: center;
}
.no-center-title-description .description {
  font: 1rem/1.3 var(--text-font-family);
  color: rgba(0 0 0 / 70%);
}
.no-center-title-description h2 {
  font: 2rem/1 var(--heading-font-family);
  font-weight: 400;
  margin-block: 0 1rem;
}
.media-blocks {
  display: flex;
  flex-direction: column;
  padding: 0 1rem 2rem;
  justify-content: center;
  gap: calc(var(--container-gutter) / 2);
}
.media-blocks .h4 {
  font-size: 1.75rem;
}
media-block {
  position: relative;
  width: 100%;
  max-width: 34.6875rem;
}
media-block:before {
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(0 0 0 / 30%);
  width: 100%;
  height: 100%;
  content: "";
  z-index: 1;
}
media-block img {
  width: 100%;
  height: auto;
  object-fit: cover;
}
.placement-grid {
  position: relative;
  z-index: 2;
  display: grid;
  place-items: center;
  justify-items: center;
  height: 100%;
  width: 100%;
}
.prose-justify-center {
  width: 80%;
  justify-self: center;
  padding: 3.5rem 2.5rem;
  background: rgba(0 0 0 / 10%);
  backdrop-filter: blur(18.58px);
}
@media screen and (min-width: 1000px) {
  .no-center-title-description {
    padding: 3rem 2.5rem 0;
  }
  .media-blocks {
    flex-direction: row;
    padding: 2.75rem 2.5rem 3rem;
  }
  media-block {
    width: 50%;
  }
}
</style>
